import { Component,
    ElementRef,
    HostListener,
    Input,
    Output,
    EventEmitter,
    ViewEncapsulation } from '@angular/core';
import { getDatatableConfig } from './vca-grid.dt.config';

let $ = require('jquery');

@Component({
  selector: '[vcaGrid]',
  encapsulation: ViewEncapsulation.None,
  styles: [require('./vca-grid.scss')],
  template: require('./vca-grid.html')
})

export class VcaGrid {

  @Input('vcaGrid') gridOptions: Object;
  @Input('gridData') gridData: Object;
  @Input('innerTableFunction') innerTableFunction: any;
  @Input('innerTableAttr') innerTableAttr: any;
  /**
   * classNames can be any class names that data table supports like compressed,
   * cell-border, hiver, row-border, stripe etc
   */
  @Input('classNames') classNames: string;
  /**
   * Array of CSS class names to listen.
   * Useful to add listeners for any cell click.
   */
  @Input('childClassesToListen') childClassesToListen: Array<string>;
  /**
   * Flag to enable listening for child CSS class.
   * Else it's unnecessary baggage for most other Grid instances which does
   * not need this functionality
   * */
  @Input('enableListeningOnChildClasses') enableListeningOnChildClasses: boolean;
  @Input('showLoadingScreen') showLoadingScreen: boolean = false;
  @Input('defaultSortColumn') defaultSortColumn: number = 0;
  @Input('defaultSortOrder') defaultSortOrder: string = 'asc';
  @Output('onSelectionChange') selectionChanged = new EventEmitter();
  @Output('onChildClassClick') childClassClicked = new EventEmitter();

  private el: HTMLElement;
  private dataTable: any;
  private tableSettings: Object = undefined;
  private isViewInit: boolean = false;

  constructor(el: ElementRef) {
    this.el = el.nativeElement;
  }

  ngOnInit() {
  }
  ngAfterViewInit() {
  }

  initTable(): void {
    this.isViewInit = true;
    let settings = getDatatableConfig();
    let options = this.gridOptions || this.tableSettings;
    Object.assign(settings, options);
    if (settings) {
      this.dataTable = $('table', this.el).DataTable(settings);
      this.initCustomDateSort();
      this.initRowClickBehaviour();
    }
    if (this.innerTableFunction) {
      let detailsControlClass = (settings.detailsControlClass) ?
          settings.detailsControlClass : 'details-control';
      this.initChildTables(detailsControlClass);
    }
    if (this.enableListeningOnChildClasses) {
      /*let childClass = (this.childClassesToListen) ?
          this.childClassesToListen : ((settings.childClassToListen) ?
          settings.childClassToListen : 'a.restore-points');
      this.initChildClassClickListener(childClass);*/
      if (this.childClassesToListen && this.childClassesToListen instanceof Array) {
        for(var i = 0; i < this.childClassesToListen.length; i++){
          this.initChildClassClickListener(this.childClassesToListen[i]);
        }
      }
    }
  }

  initCustomDateSort(): void {
    $.fn.dataTable.ext.type.order['date-sort-custom-pre'] = function ( d ) {
        let dateArray = d.split(' '); // Tue May 03 06:41:43 GMT 2016
        if (dateArray && dateArray.length === 6) {
          let dateStr = dateArray[0] + ' ' + dateArray[1] + ' ' +
              dateArray[2] + ' ' + dateArray[3] + ' ' + dateArray[5];
          let timeStamp: number = new Date(dateStr).getTime();
          return (timeStamp || 0);
        } else {
          return 0;
        }
    };
  }

  initRowClickBehaviour(): void {
      let _this = this;
      // Kill the click event handlers, else they will be getting added in each close and reopen.
      $('table.dataTable tbody', this.el).off('click', 'tr');
      let selected = [];

      $('table.dataTable tbody', this.el).on( 'click', 'tr', function (e) {
        let tr = $(this).closest('tr'),
            row = _this.dataTable.row( tr ),
            rowData = row.data() ? row.data() : 0,
            selectedIndex = tr.index(),
            index = $.inArray(rowData, selected);

        // Remove the previous selection
        _this.dataTable.$('tr.selected').removeClass('selected');

        if ( index === -1 ) {
            selected = [rowData];
            $(this).addClass('selected');
        } else {
            selected.splice(index, 1);
            $(this).removeClass('selected');
        }
        // Output the selected rows from the component
        _this.emitSelectionChange(selected,selectedIndex);
      });
  }

  initChildTables(detailsClazz) {
      let _this = this;
      // Expand row to show the child rows of VMs
      let clazz = 'span.' + detailsClazz;
      $('table.dataTable tbody', this.el).on('click', clazz, function (e){
        let tr = $(this).closest('tr');
        let row = _this.dataTable.row( tr );
        if (row.child.isShown() ) {
          // This row is already open - close it
          $('div.slider', row.child()).slideUp( function () {
              row.child.hide();
              tr.removeClass('shown');
          } );
        } else {
          // Open this row
          row.child( _this.innerTableFunction(row.data(), _this.innerTableAttr), 'no-padding' ).show();
          tr.addClass('shown');
          // Slide Animation
          $('div.slider', row.child()).slideDown();
        }
      });
  }

  initChildClassClickListener(classToListen) {
      let _this = this;
      $('table.dataTable tbody', this.el).on('click', classToListen, function (){
        let tr = $(this).closest('tr');
        let row = _this.dataTable.row( tr );
        if (_this.childClassClicked) {
          _this.childClassClicked.emit({
            rowData: row.data(),
            childClass: classToListen
          });
        }
      });
  }

  // To fix the bug: Columns are misaligned on the startup
  orderTable(): void {
    // TODO for better UX: Try to find the 'first sortable column' from here and order it.
    setTimeout(() => {
       this.dataTable && this.dataTable.order( [ this.defaultSortColumn , this.defaultSortOrder ] ).draw();
    }, 200);
  }

  emitSelectionChange(selected, selectedIndex): void {
    if (this.selectionChanged) {
      this.selectionChanged.emit({
        value: selected,
        selectedIndex: selectedIndex
      });
    }
  }

  redrawTable(tableData): void {
    // refresh table even tableData is empty (size is zero), this fixes bug 1775952
    // https://bugzilla.eng.vmware.com/show_bug.cgi?id=1775952
    if (this.dataTable && tableData && tableData instanceof Array) {
      this.dataTable.clear();
      this.dataTable.rows.add(tableData);
      this.dataTable.draw();
      this.orderTable();
    }
  }

  ngOnChanges(changes) {
    // first ngOnChanges is executed before ngOnInit().
    // It leads to Table is not yet created but the data is already passed in
    if (!this.isViewInit) {
      this.initTable();
    }

    if (this.isViewInit && changes && changes.hasOwnProperty('gridData')
        && changes.gridData && changes.gridData.hasOwnProperty('currentValue')
        && changes.gridData.currentValue) {
      this.redrawTable(changes.gridData.currentValue);
    }
  }

  ngOnDestroy() {
    this.dataTable.destroy();
    this.dataTable = undefined;
    this.tableSettings = undefined;
    this.el = undefined;
    if(this.childClassesToListen) this.childClassesToListen = undefined;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    // Hack for header misalignment
    setTimeout(() => {
      this.dataTable.order( [ 0 , 'asc' ] ).draw();
    }, 200);
  }

  deselectRow() {
    this.dataTable.$('tr.selected').removeClass('selected');
    let selected = [];
    this.emitSelectionChange(selected, -1);
  }

}



// WEBPACK FOOTER //
// ./src/common/vca-grid/vca-grid.component.ts